import angular from 'angular';
import { GerenciamentoDocumentosService } from './gerenciamentodocumentos.service';
import { GerenciamentoDocumentosIndexController } from './index/gerenciamentodocumentos.controller';
import { GerenciamentoDocumentosListRouting } from './gerenciamentodocumentos.routes';
import { ConfirmacaoExclusaoModalController } from './modal/confirmacao-exclusao.modal.controller';
import { ConfirmacaoExclusaoModalService } from './modal/confirmacao-exclusao.modal.service';
import { CancelarAssinaturaDocumentoModalController } from './modal/cancelar-assinatura.modal.controller';
import { CancelarAssinaturaDocumentoModalService } from './modal/cancelar-assinatura.modal.service';


export const GerenciamentoDocumentosModule = angular.module('GerenciamentoDocumentosModule', ['ui.router.state', ])
    .controller('GerenciamentoDocumentosIndexController', GerenciamentoDocumentosIndexController)
    .controller('ConfirmacaoExclusaoModalController', ConfirmacaoExclusaoModalController)
    .controller('CancelarAssinaturaDocumentoModalController', CancelarAssinaturaDocumentoModalController)
    .service('GerenciamentoDocumentosService', GerenciamentoDocumentosService)
    .service('ConfirmacaoExclusaoModalService', ConfirmacaoExclusaoModalService)
    .service('CancelarAssinaturaDocumentoModalService', CancelarAssinaturaDocumentoModalService)
    .config(GerenciamentoDocumentosListRouting)
    .name;
